export default __webpack_public_path__ + "media/zurb/img/events/wired/life-services-image3-3254e4a6b89f83553456a5c007e7809d.png";